var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ initialLoad: _vm.initialLoadingState },attrs:{"id":"hypefactors"}},[(_vm.initialLoadingState)?_c('div',{staticClass:"initialLoad__content"},[_c('div',{staticClass:"loader"})]):[(_vm.isOnMaintenanceMode)?_c('maintenance-mode'):_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }